import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Loader2 } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";
import { api, formatApiErrorDetail, getDevice, getUtm, getVariant, getVisitorId, track } from "../../lib/api";

export default function Notify() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Saisissez un email valide.");
      return;
    }
    if (!consent) {
      toast.error("Votre consentement est requis pour être informé.");
      return;
    }
    setLoading(true);
    try {
      const v = await getVariant();
      await api.post("/api/leads", {
        lead_type: "notification",
        email: email.trim(),
        intention_achat: "oui",
        data_consent: true,
        marketing_consent: false,
        source: "preinscription",
        visitor_id: getVisitorId(),
        variant: v.variant,
        price_shown: v.price,
        device: getDevice(),
        ...getUtm(),
      });
      track("quick_signup");
      toast.success("Inscription enregistrée. Merci !");
      navigate("/merci");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="inscription" className="py-16 sm:py-24 bg-[#141619]/40 border-y border-[#2E333D]/50" data-testid="notify-section">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <Eyebrow>Préinscription</Eyebrow>
          <SectionTitle>Vous souhaitez être parmi les premiers ?</SectionTitle>
          <p className="mt-5 text-gray-400 leading-relaxed">
            Le lancement de STOCKBOX 8 est actuellement en préparation.
            Inscrivez-vous pour être informé en priorité.
          </p>
          <p className="mt-3 font-mono text-xs uppercase tracking-widest text-gray-500">
            Aucun paiement — aucun acompte — mesure d'intérêt réel uniquement
          </p>
          <form onSubmit={submit} className="mt-9" data-testid="notify-form">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.fr" data-testid="notify-email-input"
                className="flex-1 rounded-full border border-[#2E333D] bg-[#0C0D0E] px-6 py-4 text-base text-[#F9FAFB] placeholder:text-gray-600 focus:border-[#FFC700] focus:outline-none transition-colors"
              />
              <button type="submit" disabled={loading} data-testid="notify-submit-button"
                className="inline-flex items-center justify-center gap-2 bg-[#FFC700] text-[#0C0D0E] font-bold text-sm px-8 py-4 rounded-full uppercase tracking-wide hover:bg-[#FFD83D] disabled:opacity-60 transition-all">
                {loading ? <Loader2 size={17} className="animate-spin" /> : <BellRing size={17} />}
                Je veux être informé
              </button>
            </div>
            <label className="mt-4 flex items-start justify-center gap-2.5 cursor-pointer text-xs text-gray-500" data-testid="notify-consent">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 w-3.5 h-3.5 accent-[#FFC700]" />
              <span>J'accepte d'être contacté au sujet du lancement de STOCKBOX 8.</span>
            </label>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
